import { render, staticRenderFns } from "./glbal-topic-popover.vue?vue&type=template&id=d2c1a7f0&scoped=true&"
import script from "./glbal-topic-popover.vue?vue&type=script&lang=js&"
export * from "./glbal-topic-popover.vue?vue&type=script&lang=js&"
import style0 from "./glbal-topic-popover.vue?vue&type=style&index=0&id=d2c1a7f0&lang=scss&scoped=true&"
import style1 from "./glbal-topic-popover.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c1a7f0",
  null
  
)

export default component.exports